import {Component, Input, AfterViewInit} from '@angular/core';
import {InfluencerPost, PlatformReach} from '../../../../../models/influencer';
import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../../services/user.service';

/**
 * This component is used for printing only
*/
@Component({
  selector: 'list-platform-reach',
  templateUrl: './list-platform-reach.component.html',
  styleUrls: ['./list-platform-reach.component.scss']
})
export class ListPlatformReachComponent implements AfterViewInit {
  static COMPONENT_NAME = 'ListPlatformReachComponent';
  @Input() platformReachs: InfluencerPost[] = [];
  @Input() forPayingUser = false;

  constructor(private pdfService: PdfExportService,
              private userService: UserService) {}

  get showFallbackView() {
    return this.platformReachs.length === 0
      || (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin);
  }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady(ListPlatformReachComponent.COMPONENT_NAME);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/list-platform-reach/list-platform-reach.component.ts